import {
  ArrayField,
  ChipField,
  NumberField,
  ReferenceManyField,
  SearchInput,
  SingleFieldList,
} from 'react-admin';
import CustomDataGrid from '../Components/CustomDataGrid';
import DateFieldA from '../Components/DateFieldA';
import ListA from '../Components/ListA';
import TextFieldA from '../Components/TextFieldA';

const list = (props: any) => {
  const postFilters = [<SearchInput source="q" alwaysOn />];
  return (
    <ListA {...props} filters={postFilters}>
      <CustomDataGrid>
        <ArrayField source="menuTag">
          <SingleFieldList>
            <ChipField source="name" size="small" />
          </SingleFieldList>
        </ArrayField>
        <TextFieldA source="name" />
        <NumberField source="rank" />
        <TextFieldA label="Merchant" source="stores[0].merchant.name" />
        <TextFieldA label="Signature" source="stores[0].signature" />
        <DateFieldA source="validStartDate" />
        <DateFieldA source="validEndDate" />
        <DateFieldA source="createdAt" />
        <DateFieldA source="updatedAt" />
        <TextFieldA source="id" />
      </CustomDataGrid>
    </ListA>
  );
};

export default list;
